import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { FACULTY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/faculty/")({
  component: () => <DeptContentList cfg={FACULTY} />,
});
